const KEY = "agenzee_cookie_consent";

export const getCookieConsent = () => {
  try { return JSON.parse(localStorage.getItem(KEY)); } catch { return null; }
};

export const saveCookieConsent = (choices) => {
  const rec = {
    necessary: true,
    functional: !!choices.functional,
    analytics: !!choices.analytics,
    marketing: !!choices.marketing,
    ts: new Date().toISOString(),
    version: 1,
  };
  localStorage.setItem(KEY, JSON.stringify(rec));
  window.dispatchEvent(new CustomEvent("agz-cookie-consent", { detail: rec }));
  fetch(`${process.env.REACT_APP_BACKEND_URL}/api/consent/cookies`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(rec),
  }).catch(() => {});
  return rec;
};

export const hasConsent = (cat) => cat === "necessary" || !!getCookieConsent()?.[cat];

export const openCookieSettings = () => window.dispatchEvent(new Event("agz-open-cookie-settings"));
